// src/components/BarChartDay.js

import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import Chart from 'chart.js/auto';

const BarChartDay = () => {

    const [dataValues, setDataValues] = useState([10, 8, 12, 7, 9]); // Valores de consumo
    
    const [labels, setLabels] = useState([]);

    useEffect(() => {
        // Obtener la fecha actual
        const currentDate = new Date();

        // Crear un array con los últimos 5 días
        const last5Days = Array.from({ length: 5 }, (_, index) => {
        const day = currentDate.getDate() - index;
        return day < 10 ? `0${day}` : `${day}`;
        });

        // Actualizar las etiquetas con los últimos 5 días
        setLabels(last5Days.reverse());
    }, []);


    const data = {
        labels: labels,
        datasets: [
        {
            label: 'Wh',
            data: dataValues,
            backgroundColor: ['#FF7705', '#FF7705', '#FF7705', '#FF7705', '#FF7705'],
        },
        ],
    };

  
    const options = { 
        scales: {
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: 'Wh',
                    font: {
                        size: 16, // Tamaño de fuente más grande
                        weight: 'bold', // Texto en negrita
                    },
                },
                ticks: {
                    font: {
                      size: 14, // Tamaño de fuente más grande
                      weight: 'bold', // Texto en negrita
                    },
                },
            },
            x: {
                title: {
                    display: true,
                    text: 'Día',
                    font: {
                        size: 16, // Tamaño de fuente más grande
                        weight: 'bold', // Texto en negrita
                    },
                },
                ticks: {
                    font: {
                      size: 14, // Tamaño de fuente más grande
                      weight: 'bold', // Texto en negrita
                    },
                },
            },
        },
        plugins: {
            title: {
              display: false, // Establece display en false para ocultar el título
            },
            legend: {
                display: false, // Oculta la leyenda
            }, 
        },
    };
  
    return (
        <Bar data={data} options={options} width={'100%'} height={'100%'}/>
    );
  };
  
  export default BarChartDay;